import { Component } from "react";
import { buttonPressed, noContextMenu } from "../../logic/DOMElementsRelated";
import { goToNftPath } from "../../logic/nftRelated";
import Sound from "../../logic/Sound";
import "./arpeggio.css";
import { ArpeggioKeysCard } from "./ArpeggioKeysCard";
import { ArpeggioPadsCard } from "./ArpeggioPadsCard";
import { ArpeggioRightOptionsCard } from "./ArpeggioRightOptionsCard";
import { ArpeggioStepsLigthsCard } from "./ArpeggioStepsLightsCard";
import { ArpeggioTopOptionsCard } from "./ArpeggioTopOptionsCard";

let playIntervale = null
export default class ArpeggioLogic extends Component {
  constructor(props) {
    super(props)
    this.state = {
      data: this.props.data,
      imagesSrc: this.props.data.imagesSrc,
      stepsLightsImagesSrc: [this.props.data.imagesSrc[23], this.props.data.imagesSrc[24]],
      stepsLightsVisible: [
        false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false
      ],
      activeInstrumentsPads: [
        [false, false, false, false, false, false],
        [false, false, false, false, false, false],
        [false, false, false, false, false, false],
        [false, false, false, false, false, false],
        [false, false, false, false, false, false],
        [false, false, false, false, false, false],
        [false, false, false, false, false, false],
        [false, false, false, false, false, false],
        [false, false, false, false, false, false],
        [false, false, false, false, false, false],
        [false, false, false, false, false, false],
        [false, false, false, false, false, false],
        [false, false, false, false, false, false],
        [false, false, false, false, false, false],
        [false, false, false, false, false, false],
        [false, false, false, false, false, false],
      ],
      instrumentsPadsIndexes: [
        [{row:1, col:1}, {row:1, col:2}, {row:1, col:3}, {row:1, col:4}, 
          {row:1, col:5}, {row:1, col:6}],
        [{row:2, col:1}, {row:2, col:2}, {row:2, col:3}, {row:2, col:4}, 
          {row:2, col:5}, {row:2, col:6}],
        [{row:3, col:1}, {row:3, col:2}, {row:3, col:3}, {row:3, col:4}, 
          {row:3, col:5}, {row:3, col:6}],
        [{row:4, col:1}, {row:4, col:2}, {row:4, col:3}, {row:4, col:4}, 
          {row:4, col:5}, {row:4, col:6}],
        [{row:5, col:1}, {row:5, col:2}, {row:5, col:3}, {row:5, col:4}, 
          {row:5, col:5}, {row:5, col:6}],
        [{row:6, col:1}, {row:6, col:2}, {row:6, col:3}, {row:6, col:4}, 
          {row:6, col:5}, {row:6, col:6}],
        [{row:7, col:1}, {row:7, col:2}, {row:7, col:3}, {row:7, col:4}, 
          {row:7, col:5}, {row:7, col:6}],
        [{row:8, col:1}, {row:8, col:2}, {row:8, col:3}, {row:8, col:4}, 
          {row:8, col:5}, {row:8, col:6}],
        [{row:9, col:1}, {row:9, col:2}, {row:9, col:3}, {row:9, col:4}, 
          {row:9, col:5}, {row:9, col:6}],
        [{row:10, col:1}, {row:10, col:2}, {row:10, col:3}, {row:10, col:4}, 
          {row:10, col:5}, {row:10, col:6}],
        [{row:11, col:1}, {row:11, col:2}, {row:11, col:3}, {row:11, col:4}, 
          {row:11, col:5}, {row:11, col:6}],
        [{row:12, col:1}, {row:12, col:2}, {row:12, col:3}, {row:12, col:4}, 
          {row:12, col:5}, {row:12, col:6}],
        [{row:13, col:1}, {row:13, col:2}, {row:13, col:3}, {row:13, col:4}, 
          {row:13, col:5}, {row:13, col:6}],
        [{row:14, col:1}, {row:14, col:2}, {row:14, col:3}, {row:14, col:4}, 
          {row:14, col:5}, {row:14, col:6}],
        [{row:15, col:1}, {row:15, col:2}, {row:15, col:3}, {row:15, col:4}, 
          {row:15, col:5}, {row:15, col:6}],
        [{row:16, col:1}, {row:16, col:2}, {row:16, col:3}, {row:16, col:4}, 
          {row:16, col:5}, {row:16, col:6}],
      ],
      instrumentsActiveCursor: [
        [true, false, false, false, false, false],
        [false, false, false, false, false, false],
        [false, false, false, false, false, false],
        [false, false, false, false, false, false],
        [false, false, false, false, false, false],
        [false, false, false, false, false, false],
        [false, false, false, false, false, false],
        [false, false, false, false, false, false],
        [false, false, false, false, false, false],
        [false, false, false, false, false, false],
        [false, false, false, false, false, false],
        [false, false, false, false, false, false],
        [false, false, false, false, false, false],
        [false, false, false, false, false, false],
        [false, false, false, false, false, false],
        [false, false, false, false, false, false],
      ],
      instrumentsJustCleared: [
        [false, false, false, false, false, false],
        [false, false, false, false, false, false],
        [false, false, false, false, false, false],
        [false, false, false, false, false, false],
        [false, false, false, false, false, false],
        [false, false, false, false, false, false],
        [false, false, false, false, false, false],
        [false, false, false, false, false, false],
        [false, false, false, false, false, false],
        [false, false, false, false, false, false],
        [false, false, false, false, false, false],
        [false, false, false, false, false, false],
        [false, false, false, false, false, false],
        [false, false, false, false, false, false],
        [false, false, false, false, false, false],
        [false, false, false, false, false, false],
      ],
      activeDrumsPads: [
        [false, false, false],
        [false, false, false],
        [false, false, false],
        [false, false, false],
        [false, false, false],
        [false, false, false],
        [false, false, false],
        [false, false, false],
        [false, false, false],
        [false, false, false],
        [false, false, false],
        [false, false, false],
        [false, false, false],
        [false, false, false],
        [false, false, false],
        [false, false, false],
      ],
      drumsPadsIndexes: [
        [{row:1, col:1}, {row:1, col:2}, {row:1, col:3}],
        [{row:2, col:1}, {row:2, col:2}, {row:2, col:3}],
        [{row:3, col:1}, {row:3, col:2}, {row:3, col:3}],
        [{row:4, col:1}, {row:4, col:2}, {row:4, col:3}],
        [{row:5, col:1}, {row:5, col:2}, {row:5, col:3}],
        [{row:6, col:1}, {row:6, col:2}, {row:6, col:3}],
        [{row:7, col:1}, {row:7, col:2}, {row:7, col:3}],
        [{row:8, col:1}, {row:8, col:2}, {row:8, col:3}],
        [{row:9, col:1}, {row:9, col:2}, {row:9, col:3}],
        [{row:10, col:1}, {row:10, col:2}, {row:10, col:3}],
        [{row:11, col:1}, {row:11, col:2}, {row:11, col:3}],
        [{row:12, col:1}, {row:12, col:2}, {row:12, col:3}],
        [{row:13, col:1}, {row:13, col:2}, {row:13, col:3}],
        [{row:14, col:1}, {row:14, col:2}, {row:14, col:3}],
        [{row:15, col:1}, {row:15, col:2}, {row:15, col:3}],
        [{row:16, col:1}, {row:16, col:2}, {row:16, col:3}],
      ],
      drumsActiveCursor: [
        [false, false, false],
        [false, false, false],
        [false, false, false],
        [false, false, false],
        [false, false, false],
        [false, false, false],
        [false, false, false],
        [false, false, false],
        [false, false, false],
        [false, false, false],
        [false, false, false],
        [false, false, false],
        [false, false, false],
        [false, false, false],
        [false, false, false],
        [false, false, false],
      ],
      drumsJustCleared: [
        [false, false, false],
        [false, false, false],
        [false, false, false],
        [false, false, false],
        [false, false, false],
        [false, false, false],
        [false, false, false],
        [false, false, false],
        [false, false, false],
        [false, false, false],
        [false, false, false],
        [false, false, false],
        [false, false, false],
        [false, false, false],
        [false, false, false],
        [false, false, false],
      ],
      justClearedInstrumentsPads: [
        [false, false, false, false, false, false],
        [false, false, false, false, false, false],
        [false, false, false, false, false, false],
        [false, false, false, false, false, false],
        [false, false, false, false, false, false],
        [false, false, false, false, false, false],
        [false, false, false, false, false, false],
        [false, false, false, false, false, false],
        [false, false, false, false, false, false],
        [false, false, false, false, false, false],
        [false, false, false, false, false, false],
        [false, false, false, false, false, false],
        [false, false, false, false, false, false],
        [false, false, false, false, false, false],
        [false, false, false, false, false, false],
        [false, false, false, false, false, false],
      ],
      justClearedDrumsPads: [
        [false, false, false],
        [false, false, false],
        [false, false, false],
        [false, false, false],
        [false, false, false],
        [false, false, false],
        [false, false, false],
        [false, false, false],
        [false, false, false],
        [false, false, false],
        [false, false, false],
        [false, false, false],
        [false, false, false],
        [false, false, false],
        [false, false, false],
        [false, false, false],
      ],
      playActive: false,
      currentStep: -1,
      cursorPosition: [0, 0],
      stepsAmount: 16,
      soundsAmount: 9,
      bpm: [250, 375, 500, 625, 750],
      currentBpm: 2,
      audios: [],
      clickBtnPossible : [true, true, true, true, true, true, true, true, true, true, true, true, true, true],
      monoPolyState: false, // false mono true poly
      writeModeState: false,
    }

    this.handleClick = this.handleClick.bind(this)
    this.playSequence = this.playSequence.bind(this)
    this.keyDown = this.keyDown.bind(this)
    this.keyUp = this.keyUp.bind(this)
  }

  componentDidMount() {
    this.loadSound()
    this.loadEventListener()
    noContextMenu()
  }

  componentWillUnmount() {
    this.state.audios.forEach(sound => {
      sound.stop()
    })
    this.unloadEventListener()
  }

  loadSound() {
    const audios = []

    let sound1 = new Sound(this.state.data.audios[0], 15);
    let sound2 = new Sound(this.state.data.audios[1], 15);
    let sound3 = new Sound(this.state.data.audios[2], 15);
    let sound4 = new Sound(this.state.data.audios[3], 15);
    let sound5 = new Sound(this.state.data.audios[4], 15);
    let sound6 = new Sound(this.state.data.audios[5], 15);
    let sound7 = new Sound(this.state.data.audios[6], 6);
    let sound8 = new Sound(this.state.data.audios[7], 6);
    let sound9 = new Sound(this.state.data.audios[8], 6);
  
    audios.push(sound1)
    audios.push(sound2)
    audios.push(sound3)
    audios.push(sound7)
    audios.push(sound8)
    audios.push(sound9)
    audios.push(sound4)
    audios.push(sound5)
    audios.push(sound6)

    this.setState({audios: audios})
  }

  loadEventListener() {
    window.addEventListener('keydown', this.keyDown)
    window.addEventListener('keyup', this.keyUp)
  }

  keyDown(event) {
    // console.log(event.code)
    let speedReactivation = 0
    const speedReactivationArrow = 67
    switch(event.code) {
      case "Space": 
        this.actionLimiter(0, '', 'togglePadActive', 250)
        break
        
      case "ArrowUp":
        this.actionLimiter(1, 'up', 'moveCursor', speedReactivationArrow)
        break
        
        case "ArrowRight":
          this.actionLimiter(2, 'right', 'moveCursor', speedReactivationArrow)
          break
          
        case "ArrowLeft":
          this.actionLimiter(3, 'left', 'moveCursor', speedReactivationArrow)
          break
    
      case "ArrowDown":
        this.actionLimiter(4, 'down', 'moveCursor', speedReactivationArrow)
        break

      case "KeyA":
        speedReactivation = (1000 - this.state.bpm[this.state.currentBpm])
        this.actionLimiter(5, 0, 'playSound', speedReactivation)
        break
        
      case "KeyS":
        speedReactivation = (1000 - this.state.bpm[this.state.currentBpm])
        this.actionLimiter(6, 1, 'playSound', speedReactivation)
        break

      case "KeyD":
        speedReactivation = (1000 - this.state.bpm[this.state.currentBpm])
        this.actionLimiter(7, 2, 'playSound', speedReactivation)
        break

      case "KeyF":
        speedReactivation = (1000 - this.state.bpm[this.state.currentBpm])
        this.actionLimiter(8, 3, 'playSound', speedReactivation)
        break

      case "KeyG":
        speedReactivation = (1000 - this.state.bpm[this.state.currentBpm])
        this.actionLimiter(9, 4, 'playSound', speedReactivation)
        break

      case "KeyH":
        speedReactivation = (1000 - this.state.bpm[this.state.currentBpm])
        this.actionLimiter(10, 5, 'playSound', speedReactivation)
        break

      case "KeyJ":
        speedReactivation = (1000 - this.state.bpm[this.state.currentBpm])
        this.actionLimiter(11, 6, 'playSound', speedReactivation)
        break

      case "KeyK":
        speedReactivation = (1000 - this.state.bpm[this.state.currentBpm])
        this.actionLimiter(12, 7, 'playSound', speedReactivation)
        break

      case "KeyL":
        speedReactivation = (1000 - this.state.bpm[this.state.currentBpm])
        this.actionLimiter(13, 8, 'playSound', speedReactivation)
        break
        
      case "KeyZ":
        this.changePlayMode("mono")
        break
        
      case "KeyX":
        this.changePlayMode("poly")
        break

      case "KeyC":
        if (this.state.currentBpm !== 0) this.changeBpm("minus")
        break

      case "KeyV":
        if (this.state.currentBpm !== 4) this.changeBpm("plus")
        break
      
      case "KeyB":
        this.togglePlay()
        break
          
      case "Comma":
        this.nftLink()
        break

      case "KeyN":
        this.toggleWriteMode()
        break

      case "KeyM":
        this.clearActivePads()
        break
      
      default: break
    }
  }

  keyUp(event) {
    switch(event.code) {
      case "KeyA":
        this.reactivateAction(5)
        break

      case "KeyS":
        this.reactivateAction(6)
        break

      case "KeyD":
        this.reactivateAction(7)
        break

      case "KeyF":
        this.reactivateAction(8)
        break

      case "KeyG":
        this.reactivateAction(9)
        break

      case "KeyH":
        this.reactivateAction(10)
        break

      case "KeyJ":
        this.reactivateAction(11)
        break

      case "KeyK":
        this.reactivateAction(12)
        break

      case "KeyL":
        this.reactivateAction(13)
        break

      default: break
    }
  }

  unloadEventListener() {
    window.removeEventListener('keydown', this.keyDown)
    window.removeEventListener('keyup', this.keyUp)
  }

  actionLimiter(clickPossibleIndex, functionParam, action, speedReactivation) { 
    if (this.state.clickBtnPossible[clickPossibleIndex]) {
      const clickBtnPossible = [...this.state.clickBtnPossible]
      clickBtnPossible[clickPossibleIndex] = false
      this.setState({clickBtnPossible: clickBtnPossible}, () => {
        switch(action) {
          case "togglePadActive": 
            this.togglePadActive()
            break 

          case "moveCursor": 
            this.moveCursor(functionParam)
            break 
            
          case "playSound": 
            this.verifyWriteMode(functionParam)
            break

          default: break
        }
        
        setTimeout(() => {
          const clickBtnPossible = [...this.state.clickBtnPossible]
          clickBtnPossible[clickPossibleIndex] = true
          this.setState({clickBtnPossible: clickBtnPossible})
        }, speedReactivation)
      })
    }
  }

  reactivateAction(clickPossibleIndex) {
    const clickBtnPossible = [...this.state.clickBtnPossible]
    clickBtnPossible[clickPossibleIndex] = true
    this.setState({clickBtnPossible: clickBtnPossible})
  }

  togglePadActive() {
    const currentContainer = document.getElementById('arpeggioActivatePadContainer')
    buttonPressed(currentContainer.children)
    setTimeout(() => buttonPressed(currentContainer.children), 175)

    const row = this.state.cursorPosition[0]
    let column = this.state.cursorPosition[1]

    if (column < 6) {
      const activeInstrumentsPads = [...this.state.activeInstrumentsPads]

      activeInstrumentsPads[row][column] = !activeInstrumentsPads[row][column]

    this.setState({activeInstrumentsPads: activeInstrumentsPads})
    }
    else {
      column -= 6
      const activeDrumsPads = [...this.state.activeDrumsPads]

      activeDrumsPads[row][column] = !activeDrumsPads[row][column]

      this.setState({activeDrumsPads: activeDrumsPads})
    }
  }

  moveCursor(moveTo) {
    const cursorX = this.state.cursorPosition[1]
    const cursorY = this.state.cursorPosition[0]
    const stepsAmount = this.state.stepsAmount
    const soundsAmount = this.state.soundsAmount

    let currentContainer = ''
    
    switch(moveTo) {
      case "left":
        currentContainer = document.getElementById('arpeggioArrowLeftContainer')
        buttonPressed(currentContainer.children)
        setTimeout(() => buttonPressed(currentContainer.children), 175)

        let xLeft = cursorX - 1
        if (xLeft < 0) xLeft = 0
        this.updateCursorPosition(cursorY, xLeft)
        break

      case "right":
        currentContainer = document.getElementById('arpeggioArrowRightContainer')
        buttonPressed(currentContainer.children)
        setTimeout(() => buttonPressed(currentContainer.children), 175)
        let xRight = cursorX + 1
        if (xRight > soundsAmount - 1) xRight = soundsAmount - 1
        this.updateCursorPosition(cursorY, xRight)
        break

      case "up":
        currentContainer = document.getElementById('arpeggioArrowUpContainer')
        buttonPressed(currentContainer.children)
        setTimeout(() => buttonPressed(currentContainer.children), 175)
        let yUp = cursorY - 1
        if (yUp < 0) yUp = 0
        this.updateCursorPosition(yUp, cursorX)
        break

      case "down":
        currentContainer = document.getElementById('arpeggioArrowDownContainer')
        buttonPressed(currentContainer.children)
        setTimeout(() => buttonPressed(currentContainer.children), 175)
        let yDown = cursorY + 1
        if (yDown > stepsAmount - 1) yDown = stepsAmount - 1
        this.updateCursorPosition(yDown, cursorX)
        break

      default: break
    }
  }

  updateCursorPosition(y, x) {
    let lastPositionX = this.state.cursorPosition[1]
    const lastPositionY = this.state.cursorPosition[0]
    const instrumentsActiveCursor = [...this.state.instrumentsActiveCursor]
    const drumsActiveCursor = [...this.state.drumsActiveCursor]

    if (lastPositionX < 6) {
      instrumentsActiveCursor[lastPositionY][lastPositionX] = !instrumentsActiveCursor[lastPositionY][lastPositionX]
    }
    else {
      const lastPositionXTemp = lastPositionX - 6
      drumsActiveCursor[lastPositionY][lastPositionXTemp] = !drumsActiveCursor[lastPositionY][lastPositionXTemp]
    }

    if (x < 6) instrumentsActiveCursor[y][x] = true
    else {
      const xTemp = x - 6
      drumsActiveCursor[y][xTemp] = true
    }

    this.setState({cursorPosition: [y, x], instrumentsActiveCursor: instrumentsActiveCursor, drumsActiveCursor: drumsActiveCursor})
  }

  verifyWriteMode(soundToPlay) {
    if (!this.state.writeModeState) {
      if (soundToPlay < 6) this.playInstrumentsSound(soundToPlay)
      else this.playUniqueDrumSound(soundToPlay)
    }
    else {
      if (!this.state.playActive) {
        if (soundToPlay < 6) this.playInstrumentsSound(soundToPlay)
        else this.playUniqueDrumSound(soundToPlay)
      }
      else this.togglePadActiveFromKeys(soundToPlay)
    }
  }

  togglePadActiveFromKeys(padToActivate) {
    const activeInstrumentsPads = [...this.state.activeInstrumentsPads]
    const activeDrumsPads = [...this.state.activeDrumsPads]
    
    const currentStep = this.state.currentStep % this.state.stepsAmount
    const inversePositionStep = 15
    const currentStepInversed = inversePositionStep - currentStep

    const padType = padToActivate < 6 ? "instruments" : "drums"

    switch(padType) {
      case "instruments":
        activeInstrumentsPads[currentStepInversed][padToActivate] = !activeInstrumentsPads[currentStepInversed][padToActivate]
        this.setState({activeInstrumentsPads: activeInstrumentsPads})
        break

      case "drums":
        const drumPadToActivate = padToActivate - 6
        activeDrumsPads[currentStepInversed][drumPadToActivate] = !activeDrumsPads[currentStepInversed][drumPadToActivate]
        this.setState({activeDrumsPads: activeDrumsPads})
        break

      default: break
    }
  }

  playInstrumentsSound(soundToPlay) { 
    if (!this.state.monoPolyState) this.stopAllInstrumentsSounds()
    else this.state.audios[soundToPlay].stop()
    this.state.audios[soundToPlay].play()
  }

  playUniqueDrumSound(soundToPlay) {
    this.state.audios[soundToPlay].play()
  }

  stopAllSounds() {
    this.state.audios.forEach(note => {
      note.stop()
    })
  }

  stopAllInstrumentsSounds() {
    for (let i = 0; i < 6; i++) {
      this.state.audios[i].stop();
    }
  }

  changePlayMode(state) {
    switch(state) {
      case "mono":
        if (this.state.monoPolyState) this.setToMonoState()
        break

      case "poly":
        if (!this.state.monoPolyState) this.setToPolyState()
        break

      default: break
    }
  }

  setToMonoState() {
    this.setState({monoPolyState: false})
    this.stopAllInstrumentsSounds()
  }

  setToPolyState() {
    this.setState({monoPolyState: true})
    this.stopAllInstrumentsSounds()
  }

  changeBpm(type) {
    let currentBpm = this.state.currentBpm
    // let currentContainer = ''

    switch(type) {
      case "minus": 
        // changer la nomentlature des containers des bpm ou leur façons d;afficher leurs images
        // currentContainer = document.getElementById('sekansBpmMinusContainer')
        // buttonPressed(currentContainer.children)
        // setTimeout(() => buttonPressed(currentContainer.children), 175)
        currentBpm--
        break
      
      case "plus":
        // currentContainer = document.getElementById('sekansBpmPlusContainer')
        // buttonPressed(currentContainer.children)
        // setTimeout(() => buttonPressed(currentContainer.children), 175)
        currentBpm++
        break
      
      default: break
    }

    this.setState({currentBpm: currentBpm}, () => {
      if (this.state.playActive) {
        clearInterval(playIntervale)
        const speed = ((1000 * 60) / this.state.bpm[this.state.currentBpm])
        playIntervale = setInterval(this.playSequence, speed)
      }
    })
  }

  togglePlay() {
    const currentContainer = document.getElementById('arpeggioPlayContainer')
    buttonPressed(currentContainer.children)

    this.setState(prevState => {
      return ({playActive: !prevState.playActive})
    }, () => {
      this.verifyPlaying()
    })
  }

  verifyPlaying() {
    if (this.state.playActive) {
      const vitesse = ((1000 * 60) / this.state.bpm[this.state.currentBpm])
      playIntervale = setInterval(this.playSequence, vitesse)
    }
    else {
      clearInterval(playIntervale)
      this.setState({currentStep: -1}, this.clearLightsPosition)
      this.stopAllSounds()
    }
  }

  clearLightsPosition() {
    const stepsLightsVisible = [...this.state.stepsLightsVisible]

    for (let i = 0; i < stepsLightsVisible.length; i++) {
      stepsLightsVisible[i] = false
    }
    this.setState({stepsLightsVisible: stepsLightsVisible})
  }

  playSequence() {
    this.setState(prevState => {
      return ({currentStep: prevState.currentStep + 1})
    }, () => {
      this.showPosition()
      this.playSound()
    })
  }

  showPosition() {
    const inversePositionStep = 15
    const stepsLightsVisible = [...this.state.stepsLightsVisible]
    const currentStep = this.state.currentStep % this.state.stepsAmount
    const lastStep = (this.state.currentStep - 1) % this.state.stepsAmount

    const currentStepInversed = inversePositionStep - currentStep
    const lastStepInversed = inversePositionStep - lastStep


    if (lastStep !== -1) {
      stepsLightsVisible[lastStepInversed] = !stepsLightsVisible[lastStepInversed]
    }

    stepsLightsVisible[currentStepInversed] = !stepsLightsVisible[currentStepInversed]

    this.setState({stepsLightsVisible: stepsLightsVisible})
  }

  playSound() {
    const activeInstrumentsPads = this.state.activeInstrumentsPads
    const activeDrumsPads = this.state.activeDrumsPads
    
    const currentStep = this.state.currentStep % this.state.stepsAmount
    const inversePositionStep = 15
    const currentStepInversed = inversePositionStep - currentStep
    
    const audios = this.state.audios

    const playInstrumentsSoundsArr = []
    const playDrumsSoundsArr = []
    
    activeInstrumentsPads[currentStepInversed].forEach(pad => {
      playInstrumentsSoundsArr.push(pad)
    })
    
    if (!this.state.monoPolyState) {
      let lastTrueIndex = -(1)
      for (let i = 0; i < 6 ; i++) {
        if (playInstrumentsSoundsArr[i]) {
          if (lastTrueIndex !== -(1)) playInstrumentsSoundsArr[lastTrueIndex] = false
          lastTrueIndex = i
        }
      }
    }
    
    activeDrumsPads[currentStepInversed].forEach(pad => {
      playDrumsSoundsArr.push(pad)
    })

    playInstrumentsSoundsArr.forEach((sound, index) => {
      if (sound) {
        if (!this.state.monoPolyState) {
          this.stopAllInstrumentsSounds()
        }
        else audios[index].stop()
        audios[index].play()
      }
    })
    
    playDrumsSoundsArr.forEach((sound, index) => {
      if (sound) {
        audios[index + 6].play()
      }
    })
  }

  nftLink() {
    const currentContainer = document.getElementById('arpeggioNftLinkContainer')
    buttonPressed(currentContainer.children)

    const path = this.state.data.nftPath
    setTimeout(() => {
      buttonPressed(currentContainer.children)
      goToNftPath(path)
    }, 175)
  }

  clearActivePads() {
    const currentContainer = document.getElementById('arpeggioWipeContainer')
    buttonPressed(currentContainer.children)
    setTimeout(() => buttonPressed(currentContainer.children), 175)

    const activeInstrumentsPads = [...this.state.activeInstrumentsPads]
    const justClearedInstrumentsPads = [...this.state.justClearedInstrumentsPads]
    const activeDrumsPads = [...this.state.activeDrumsPads]
    const justClearedDrumsPads = [...this.state.justClearedDrumsPads]

    activeInstrumentsPads.forEach(row => {
      for (let i = 0; i < row.length; i++) {
        row[i] = false
      }
    })

    activeDrumsPads.forEach(row => {
      for (let i = 0; i < row.length; i++) {
        row[i] = false
      }
    })

    justClearedInstrumentsPads.forEach(row => {
      for (let i = 0; i < row.length; i++) {
        row[i] = true
      }
    })

    justClearedDrumsPads.forEach(row => {
      for (let i = 0; i < row.length; i++) {
        row[i] = true
      }
    })

    setTimeout(() => {
      justClearedInstrumentsPads.forEach(row => {
        for (let i = 0; i < row.length; i++) {
          row[i] = false
        }
      })
  
      justClearedDrumsPads.forEach(row => {
        for (let i = 0; i < row.length; i++) {
          row[i] = false
        }
      })

      this.setState({justClearedInstrumentsPads: justClearedInstrumentsPads, justClearedDrumsPads: justClearedDrumsPads})
    }, 300)

    this.setState({activeInstrumentsPads: activeInstrumentsPads, activeDrumsPads:activeDrumsPads, justClearedInstrumentsPads: justClearedInstrumentsPads, justClearedDrumsPads: justClearedDrumsPads})
  }

  toggleWriteMode() {
    let writeModeState = this.state.writeModeState

    writeModeState = !writeModeState

    this.setState({writeModeState: writeModeState})
  }
  
  handleClick(event) {
    switch(event.target.parentElement.dataset.action) {
      case "monoState":
        this.changePlayMode("mono")
        break

      case "polyState":
        this.changePlayMode("poly")
        break

      case "bpmDisplay":
        switch(event.target.parentElement.dataset.position) {
          case "1":
            this.changeBpm('minus')
            break

          case "2":
            this.changeBpm('minus')
            break

          case "3":
            this.changeBpm('minus')
            break

          case "4":
            this.changeBpm('plus')
            break

          case "5":
            this.changeBpm('plus')
            break

          default:break
        }
        break

      case "togglePadStatus":
        this.activatePad(event.target)
        break

      case "playSingleSound":
        const index = parseInt(event.target.dataset.note) - 1
        this.verifyWriteMode(index)
        break

      case "playSequence":
        this.togglePlay()
        break

      case "toggleWriteActive":
        this.toggleWriteMode()
        break
        
      case "activatePad":
        this.togglePadActive()
        break

      case "moveCursor":
        this.moveCursor(event.target.parentElement.dataset.direction)
        break

      case "wipeAll":
        this.clearActivePads()
        break

      case "nftLink":
        this.nftLink()
        break
        
      default:break
    }
  }

  activatePad(pad) {
    const row = pad.dataset.row - 1
    const col = pad.dataset.col - 1
    switch(pad.dataset.padstype) {
      case "instruments":
        const activeInstrumentsPads = [...this.state.activeInstrumentsPads]
        activeInstrumentsPads[row][col] = !activeInstrumentsPads[row][col]
        this.setState({activeInstrumentsPads: activeInstrumentsPads}, () => {
          this.updateCursorPosition(row, col)
        })
        
        break

      case "drums":
        const activeDrumsPads = [...this.state.activeDrumsPads]
        activeDrumsPads[row][col] = !activeDrumsPads[row][col]
        this.setState({activeDrumsPads: activeDrumsPads}, () => {
          this.updateCursorPosition(row, col + 6)
        })
        
        break

      default: break
    }
  }

  render() {
    return (
      <div id="container-MPT" style={{height: this.props.height, width: this.props.width}}>
        <img draggable="false" className="noContextMenu" id="arpeggioFrameImg" src={this.state.imagesSrc[29]} alt="MPT Frame" /> 
        <ArpeggioTopOptionsCard imgSrc={this.state.imagesSrc} handleClick={this.handleClick} monoPolyState={this.state.monoPolyState} />
        <ArpeggioStepsLigthsCard stepsLightsVisible={this.state.stepsLightsVisible} stepsLightsImagesSrc={this.state.stepsLightsImagesSrc} />
        <ArpeggioPadsCard activePads={this.state.activeInstrumentsPads} padsIndexes={this.state.instrumentsPadsIndexes} activeCursor={this.state.instrumentsActiveCursor} handleClick={this.handleClick} justCleared={this.state.justClearedInstrumentsPads} handlePointer={this.handlePointer} edition={this.state.data.edition} padsType="instruments" />
        <ArpeggioPadsCard activePads={this.state.activeDrumsPads} padsIndexes={this.state.drumsPadsIndexes} activeCursor={this.state.drumsActiveCursor} handleClick={this.handleClick} justCleared={this.state.justClearedDrumsPads} handlePointer={this.handlePointer} edition={this.state.data.edition} padsType="drums"/>
        <ArpeggioKeysCard handleClick={this.handleClick} />
        <ArpeggioRightOptionsCard imgSrc={this.state.imagesSrc} handleClick={this.handleClick} writeModeState={this.state.writeModeState} playActive={this.state.playActive} />
      </div>
    )
  }
}